import moment from 'moment';
import 'moment/locale/pt-br';

import type { Installment, Invoice } from './types';

moment.locale('pt-br');

export type InvoiceSortKey = 'nota' | 'emissao' | 'valor';

export const ORDER_BY_MAP: Record<
  InvoiceSortKey,
  { asc: string; desc: string }
> = {
  nota: {
    asc: 'invoiceNumber ASC',
    desc: 'invoiceNumber DESC',
  },
  emissao: {
    asc: 'emissionDate ASC',
    desc: 'emissionDate DESC',
  },
  valor: {
    asc: 'amountOriginal ASC',
    desc: 'amountOriginal DESC',
  },
};

export const parseOrderBy = (
  orderBy: string
): { key: InvoiceSortKey | null; direction: 'asc' | 'desc' | null } => {
  if (orderBy.startsWith('invoiceNumber')) {
    return {
      key: 'nota',
      direction: orderBy.includes('DESC') ? 'desc' : 'asc',
    };
  }

  if (orderBy.startsWith('emissionDate')) {
    return {
      key: 'emissao',
      direction: orderBy.includes('DESC') ? 'desc' : 'asc',
    };
  }

  if (orderBy.startsWith('amountOriginal')) {
    return {
      key: 'valor',
      direction: orderBy.includes('DESC') ? 'desc' : 'asc',
    };
  }

  return { key: null, direction: null };
};

export const formatEmissionDate = (invoice: Invoice): string => {
  if (!invoice.emissionDate) return '-';

  const label = moment(invoice.emissionDate).format('MMM/YYYY');
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const formatInvoiceAmount = (installment: Installment): string => {
  if (installment.amountOriginal == null) return '-';

  return installment.amountOriginal.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const formatSelectedTotal = (
  amounts: number[]
): string => {
  const total = amounts.reduce((sum, value) => sum + value, 0);

  return total.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};
